<template>
  <div data-test="keywords">
    <div id="keywords">
      <div class="columns has-text-centered">
        <div class="column is-6">
          <rank-display
            indicator="up"
            :large="true"
          >
            {{ data.up }}
          </rank-display>
        </div>
        <div class="column is-6">
          <rank-display
            indicator="down"
            :large="true"
          >
            {{ data.down }}
          </rank-display>
        </div>
      </div>
      <div class="columns has-text-centered">
        <div class="column is-6">
          <rank-display
            indicator="noChange"
            :large="true"
          >
            {{ data.no_change }}
          </rank-display>
        </div>
        <div class="column is-6">
          <rank-display
            indicator="new"
            :large="true"
          >
            {{ data.new }}
          </rank-display>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import RankDisplay from '@/components/Shared/RankDisplay'

export default {
  name: 'BaseRankChangeAllKeywords',

  components: {
    RankDisplay
  },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
